// Compatibility shim for old call sites. Customer-flow analytics now uses
// structured events from ga4.js exclusively; no legacy event is emitted or stored.
const sendAnalytics = () => false;

if (typeof window !== "undefined") {
  window.__cdSendAnalytics = sendAnalytics;
}

export const legacyEvent = () => null;
export default sendAnalytics;